var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.doc)?_c('div',[_c('div',{staticClass:"printFooter"},[_vm._v(_vm._s(_vm.doc.subtype)+" | Analyscenter")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }